import { useCallback, useMemo } from 'react';
import { selectPermissionsArray } from '@store/Login/authSelectors';
import { useAppSelector } from '@store/hooks';

export const usePermissions = () => {
  const permissions = useAppSelector(selectPermissionsArray); // string[]

  const permSet = useMemo(() => new Set(permissions ?? []), [permissions]);

  const can = useCallback((p: string) => permSet.has(p), [permSet]);

  const canAny = useCallback((ps: string[]) => ps.some(p => permSet.has(p)), [permSet]);

  const canAll = useCallback((ps: string[]) => ps.every(p => permSet.has(p)), [permSet]);

  return { can, canAny, canAll };
};
